import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { RootModule } from './root.module';
import 'hammerjs';
platformBrowserDynamic().bootstrapModule(RootModule);
